const SITE_KEY = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY || "";

let scriptLoaded = false;
let scriptLoading: Promise<void> | null = null;

/** Load the reCAPTCHA v3 script (idempotent) */
function loadScript(): Promise<void> {
  if (scriptLoaded) return Promise.resolve();
  if (scriptLoading) return scriptLoading;

  scriptLoading = new Promise<void>((resolve, reject) => {
    if (typeof window === "undefined") return reject();
    if (document.querySelector(`script[src*="recaptcha"]`)) {
      scriptLoaded = true;
      return resolve();
    }
    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
    script.async = true;
    script.onload = () => {
      scriptLoaded = true;
      resolve();
    };
    script.onerror = () => reject(new Error("Failed to load reCAPTCHA"));
    document.head.appendChild(script);
  });

  return scriptLoading;
}

/** Get a reCAPTCHA v3 token for the given action */
export async function getRecaptchaToken(action: string): Promise<string> {
  if (!SITE_KEY) return "";
  await loadScript();
  return new Promise((resolve) => {
    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(SITE_KEY, { action }).then(resolve);
    });
  });
}

// Type augmentation for window.grecaptcha
declare global {
  interface Window {
    grecaptcha: {
      ready: (cb: () => void) => void;
      execute: (siteKey: string, options: { action: string }) => Promise<string>;
    };
  }
}
